import * as ActionTypes from '../constants/actionTypes';
import {pricingService}  from '../services/pricingService';

import { toast } from 'react-toastify';

export function getPrice(priceRequest) {
    return dispatch => {
        dispatch(request());
        return pricingService.getPrice(priceRequest)
        .then((response) => {
            let data = response.data;
            dispatch(success(data));
        })
        .catch(error => dispatch(failure(error)));
    };
    function request() { return { type: ActionTypes.GET_PARKING_PRICE_REQUEST }; }
    function success(data) { return { type: ActionTypes.GET_PARKING_PRICE_SUCCESS, data }; }
    function failure(error) {
        toast.error("Unable to retrieve the parking price.", {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.GET_PARKING_PRICE_FAILURE, error };
    }
}

export function calculateAdditionalService(pricingModel){
    return { type: ActionTypes.UPDATE_PRICE, pricingModel };
}
export function SelectPricingModel(pricingModel){
    return { type: ActionTypes.SET_SELECT_PRICING, pricingModel };
}
export function UpdateCardNumber(cardNumber){
    return { type: ActionTypes.UPDATE_CARD_NUMBER, cardNumber }; 
}
export function UpdateExpiryDate(expiryDate){
    return { type: ActionTypes.UPDATE_EXPIRY_DATE, expiryDate }; 
}
export function UpdateCVC(cvc){
    return { type: ActionTypes.UPDATE_CVC, cvc }; 
}




// WEBPACK FOOTER //
// ./src/actions/pricingActions.js